module.exports = __webpack_public_path__ + "static/media/student19.f589fad0.png";